import { render, staticRenderFns } from "./List-User-VehicleDepartment.vue?vue&type=template&id=48d69a7b"
import script from "./List-User-VehicleDepartment.vue?vue&type=script&lang=js"
export * from "./List-User-VehicleDepartment.vue?vue&type=script&lang=js"
import style0 from "./List-User-VehicleDepartment.vue?vue&type=style&index=0&id=48d69a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports